function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { format as formatFn, isValid, parse as parseFn, isSameSecond, isSameDay } from 'date-fns';
import { isArray } from '@cloud-sn/v-utils';
import MultiCalendarMixin from '../mixins/multiCalendar';
var __vue_script__ = {
  name: 'DateInput',
  mixins: [MultiCalendarMixin],
  props: {
    prefixCls: {
      type: String,
      default: ''
    },
    value: {
      type: [Date, Array],
      default: undefined
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    format: {
      type: String,
      default: ''
    },
    locale: {
      type: Object,
      default: null
    },
    showClear: {
      type: Boolean,
      default: false
    },
    disabledDate: {
      type: Function,
      default: function _default() {
        return false;
      }
    },
    disabledTime: {
      type: Function,
      default: function _default() {
        return false;
      }
    }
  },
  data: function data() {
    return {
      prevVal: '',
      innerValue: '',
      invalid: false
    };
  },
  computed: {
    inputClasses: function inputClasses() {
      var _ref;

      var prefixCls = this.prefixCls,
          invalid = this.invalid;
      return _ref = {}, _defineProperty(_ref, "".concat(prefixCls, "-input"), true), _defineProperty(_ref, "".concat(prefixCls, "-input-invalid"), invalid), _ref;
    }
  },
  watch: {
    value: function value(nVal, oVal) {
      if (nVal !== oVal) {
        this.initInputVal();
      }
    }
  },
  created: function created() {
    this.initInputVal();
  },
  methods: {
    initInputVal: function initInputVal() {
      var value = this.value,
          format = this.format,
          isMultiCalendarChildren = this.isMultiCalendarChildren,
          mutliFormatSeparator = this.mutliFormatSeparator;

      if (isMultiCalendarChildren) {
        if (isArray(value)) {
          this.innerValue = value.map(function (v) {
            return formatFn(v, format);
          }).join(mutliFormatSeparator);
        } else {
          this.innerValue = '';
        }

        return;
      }

      if (!value) {
        return;
      }

      var parsedVal = parseFn(value);

      if (isValid(parsedVal)) {
        this.prevVal = parsedVal;
        this.innerValue = formatFn(parsedVal, format);
      }
    },
    isSameFn: function isSameFn(originVal, val) {
      var hasTimePicker = this.hasTimePicker;
      return hasTimePicker ? isSameSecond(originVal, val) : isSameDay(originVal, val);
    },

    /**
     * input readonly属性为true, 用户无法触发change事件,单测暂时忽略
     */

    /* istanbul ignore next */
    onChange: function onChange(e) {
      var value = e.target.value;
      var prevVal = this.prevVal,
          isSameFn = this.isSameFn,
          format = this.format;
      this.innerValue = value;
      this.invalid = false;

      if (!value) {
        this.prevVal = value;
        this.invalid = false;
        this.$emit('on-change', null);
        return;
      }

      var parsedVal = parseFn(value);

      if (!isValid(parsedVal)) {
        this.invalid = true;
        return;
      }

      if (!prevVal || !isSameFn(prevVal, parsedVal)) {
        this.$emit('on-change', parsedVal);
      } else {
        // 防止只是格式变更, 重新格式化为标准格式
        this.innerValue = formatFn(parsedVal, format);
      }
    },
    onClear: function onClear() {
      this.innerValue = '';
      this.$emit('on-clear', null);
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    class: _vm.prefixCls + "-input-wrap"
  }, [_c('div', {
    class: _vm.prefixCls + "-date-input-wrap"
  }, [_c('input', {
    class: _vm.inputClasses,
    attrs: {
      "title": _vm.innerValue,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled,
      "readonly": ""
    },
    domProps: {
      "value": _vm.innerValue
    },
    on: {
      "change": _vm.onChange
    }
  })]), _vm._v(" "), _vm.showClear ? _c('a', {
    class: _vm.prefixCls + "-clear-btn",
    attrs: {
      "role": "button",
      "title": _vm.locale.clear
    },
    on: {
      "click": _vm.onClear
    }
  }) : _vm._e()]);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "dateInput.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);